/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import './close_account';
import '../../../services/account/retrieve_account';
import './retrieve_account_details';
import './create_account';
import './update_account';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "sfs": {
        "nested": {
          "external": {
            "nested": {
              "service": {
                "nested": {
                  "AccountService": {
                    "methods": {
                      "CloseAccount": {
                        "requestType": ".squareup.sfs.external.service.CloseAccountRequest",
                        "responseType": ".squareup.sfs.external.service.CloseAccountResponse"
                      },
                      "RetrieveAccount": {
                        "requestType": ".squareup.sfs.service.RetrieveAccountRequest",
                        "responseType": ".squareup.sfs.service.RetrieveAccountResponse"
                      },
                      "RetrieveAccountDetails": {
                        "requestType": ".squareup.sfs.external.service.RetrieveAccountDetailsRequest",
                        "responseType": ".squareup.sfs.external.service.RetrieveAccountDetailsResponse"
                      },
                      "CreateAccount": {
                        "requestType": ".squareup.sfs.external.service.CreateAccountRequest",
                        "responseType": ".squareup.sfs.external.service.CreateAccountResponse"
                      },
                      "UpdateAccount": {
                        "requestType": ".squareup.sfs.external.service.UpdateAccountRequest",
                        "responseType": ".squareup.sfs.external.service.UpdateAccountResponse"
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.sfs?.nested?.external?.nested?.service?.nested?.AccountService) {
  $root.addJSON(jsonData);
}

/**
 * --
 * @desc External RPCs for viewing account details, balance, and other account specific operations
 * --
 *
 * SOURCE AccountService @ squareup/sfs/external/services/account/account_service.proto at 15:1
 */
export const AccountService = $root.lookupService('squareup.sfs.external.service.AccountService');